/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiUserTermsStatusFromJSON, StreemApiUserTermsStatusToJSON, } from './';
export function StreemApiGetUserTermsStatusResponseFromJSON(json) {
    return StreemApiGetUserTermsStatusResponseFromJSONTyped(json, false);
}
export function StreemApiGetUserTermsStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : StreemApiUserTermsStatusFromJSON(json['status']),
    };
}
export function StreemApiGetUserTermsStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': StreemApiUserTermsStatusToJSON(value.status),
    };
}
//# sourceMappingURL=StreemApiGetUserTermsStatusResponse.js.map